const LOCATION_LOADING = (state) => {
  state.locationLoading = true
  state.locationError = false
}

const LOCATION_UPDATED = (state, states) => {
  state.locationLoading = false
  state.locations = states
}

const LOCATION_ERROR = (state) => {
  state.locationLoading = false
  state.locationError = true
}

const CITIES_LOADING = (state) => {
  state.citiesLoading = true
  state.citiesError = false
}

const CITIES_UPDATED = (state, states) => {
  state.citiesLoading = false
  state.cities = states
}

const CITIES_ERROR = (state) => {
  state.citiesLoading = false
  state.citiesError = true
}

const BANKS_LOADING = (state) => {
  state.banksLoading = true
  state.banksError = false
}

const BANKS_UPDATED = (state, banks) => {
  state.banksLoading = false
  state.banks = banks
}

const BANKS_ERROR = (state) => {
  state.banksLoading = false
  state.banksError = true
}

const RECRUITMENT_CHANNELS_LOADING = (state) => {
  state.recruitmentChannelsLoading = true
  state.recruitmentChannelsError = false
}

const NETWORKS_LOADING = (state) => {
  state.networksLoading = true
  state.networksError = false
}

const JFORCETYPES_LOADING = (state) => {
  state.jforceTypesLoading = true
  state.jforceTypesError = false
}

const TIMESLOTS_LOADING = (state) => {
  state.timeSlotsLoading = true
  state.timeSlotsError = false
}

const LANGUAGES_LOADING = (state) => {
  state.languagesLoading = true
  state.languagesError = false
}

const RECRUITMENT_CHANNELS_UPDATED = (state, recruitmentChannels) => {
  state.recruitmentChannelsLoading = false
  state.recruitmentChannels = recruitmentChannels
}

const NETWORKS_UPDATED = (state, networks) => {
  state.networksLoading = false
  state.networkList = networks
}

const JFORCETYPES_UPDATED = (state, types) => {
  state.jforceTypesLoading = false
  state.jforceTypes = types
}

const LANGUAGES_UPDATED = (state, languages) => {
  state.languagesLoading = false
  state.languageList = languages
}

const TIMESLOTS_UPDATED = (state, slots) => {
  state.timeSlotsLoading = false
  state.timeSlots = slots
}

const RECRUITMENT_CHANNELS_ERROR = (state) => {
  state.recruitmentChannelsLoading = false
  state.recruitmentChannelsError = true
}

const NETWORKS_ERROR = (state) => {
  state.networksLoading = false
  state.networksError = true
}

const JFORCETYPES_ERROR = (state) => {
  state.jforceTypesLoading = false
  state.jforceTypesError = true
}

const LANGUAGES_ERROR = (state) => {
  state.languagesLoading = false
  state.languagesError = true
}

const TIMESLOTS_ERROR = (state) => {
  state.timeSlotsLoading = false
  state.timeSlotsError = true
}

const PAYMENT_METHOD_LOADING = (state) => {
  state.paymentMethodLoading = true
  state.paymentMethodError = false
}

const PAYMENT_METHOD_UPDATED = (state, paymentMethod) => {
  state.paymentMethodLoading = false
  state.paymentMethod = paymentMethod

  if (!state.paymentMethods) {
    state.paymentMethods = {}
  }
  state.paymentMethods[paymentMethod.id] = paymentMethod

  state.paymentMethodNeedConfirmation = false
}

const PAYMENT_METHOD_ERROR = (state) => {
  state.paymentMethodLoading = false
  state.paymentMethodError = true
}

const AVAILABLE_PAYMENT_METHODS_LOADING = (state) => {
  state.availablePaymentMethodsLoading = true
  state.availablePaymentMethodsError = false
}

const AVAILABLE_PAYMENT_METHODS_UPDATED = (state, availablePaymentMethods) => {
  state.availablePaymentMethodsLoading = false
  state.availablePaymentMethods = availablePaymentMethods
}

const AVAILABLE_PAYMENT_METHODS_ERROR = (state) => {
  state.availablePaymentMethodsLoading = false
  state.availablePaymentMethodsError = true
}

const PAYMENT_METHODS_LOADING = (state) => {
  state.paymentMethodsLoading = true
  state.paymentMethodsError = false
}

const PAYMENT_METHODS_UPDATED = (state, paymentMethods) => {
  state.paymentMethodsLoading = false
  state.paymentMethods = paymentMethods
}

const PAYMENT_METHODS_ERROR = (state) => {
  state.paymentMethodsLoading = false
  state.paymentMethodsError = true
}

const PAYMENT_METHOD_ADDED = (state, paymentMethod) => {
  state.hasPaymentMethod = true
  state.paymentMethodNeedConfirmation = false

  if (!state.paymentMethods) {
    state.paymentMethods = {}
  }

  state.paymentMethods[paymentMethod.id] = paymentMethod
}

const TERMS_AND_CONDITIONS_ACCEPTED = (state) => {
  state.acceptedTermsAndCondition = true
}

const USER_TYPES_TOGGLE = (state, type) => {
  state.account_type = type
}

const IS_IMPERSONATE = (state, value) => {
  state.isImpersonate = value
}

const KYC_FIELDS = (state, data) => {
  state.updated_jforce_agreement_content = data.content
  state.updated_jforce_agreement_pdf = data.pdf
}

const USER_UPDATED = (state, consultant) => {
  if (consultant.id) state.id = consultant.id
  if (consultant.external_id) state.external_id = consultant.external_id
  if (consultant.agreementDate) state.agreementDate = consultant.agreementDate
  if (consultant.jumiaId) state.jumiaId = consultant.jumiaId
  if (consultant.firstName) state.firstName = consultant.firstName
  if (consultant.lastName) state.lastName = consultant.lastName
  if (consultant.birthday) state.birthday = consultant.birthday
  if (consultant.phoneNumberCode) { state.phoneNumberCode = consultant.phoneNumberCode }
  if (consultant.phoneNumber) state.phoneNumber = consultant.phoneNumber
  if (consultant.levelId) state.levelId = consultant.levelId
  if (consultant.gender) state.gender = consultant.gender
  if (consultant.locationId) state.locationId = consultant.locationId
  if (consultant.timeslotId) state.timeslotId = consultant.timeslotId
  if (consultant.timeslotName) state.timeslotName = consultant.timeslotName
  if (consultant.stateId) state.stateId = consultant.stateId
  if (consultant.recruitmentChannelId) { state.recruitmentChannelId = consultant.recruitmentChannelId }
  if (consultant.recruitmentChannel) { state.recruitmentChannel = consultant.recruitmentChannel }
  if (consultant.locationName) state.locationName = consultant.locationName
  if (consultant.stateName) state.stateName = consultant.stateName
  if (consultant.email) state.email = consultant.email
  state.languages = consultant.languages
  state.networks = consultant.networks
  state.trained = consultant.trained
  state.is_convicted = consultant.is_convicted
  if (consultant.own_store) state.own_store = consultant.own_store
  if (consultant.sales_experience) { state.sales_experience = consultant.sales_experience }
  state.tax_id_number = consultant.tax_id_number
  state.id_card_number = consultant.id_card_number
  state.id_card_picture = consultant.id_card_picture
  if (consultant.account_type) state.account_type = consultant.account_type
  if (consultant.store_type) state.store_type = consultant.store_type
  if (consultant.is_relative_in_jumia) { state.is_relative_in_jumia = consultant.is_relative_in_jumia }
  if (consultant.store_name) state.store_name = consultant.store_name
  state.store_photo = consultant.store_photo
  state.profile_picture = consultant.profile_picture
  state.kraPin = consultant.kraPin
  state.geo_location = consultant.geo_location
  if (consultant.address) state.address = consultant.address

  state.phoneNumberError = false
  state.firstNameError = false
  state.lastNameError = false
  state.emailError = false

  if (consultant.isAuth !== undefined) state.isAuth = consultant.isAuth
  if (consultant.isInactive !== undefined) { state.isInactive = consultant.isInactive }
  if (consultant.isJForce !== undefined) state.isJForce = consultant.isJForce
  if (consultant.isPaymentMethodMandatory !== undefined) { state.isPaymentMethodMandatory = consultant.isPaymentMethodMandatory }
  if (consultant.acceptedTermsAndCondition !== undefined) { state.acceptedTermsAndCondition = consultant.acceptedTermsAndCondition }
  if (consultant.paymentMethodNeedConfirmation !== undefined) {
    state.paymentMethodNeedConfirmation =
      consultant.paymentMethodNeedConfirmation
  }
  if (consultant.hasPaymentMethod !== undefined) { state.hasPaymentMethod = consultant.hasPaymentMethod }
  if (consultant.mandatoryPaymentMethod !== undefined) { state.mandatoryPaymentMethod = consultant.mandatoryPaymentMethod }
  state.updated_jforce_agreement = consultant.updated_jforce_agreement
  state.status = consultant.status

  state.subject_id = consultant.subject_id
  state.signature = consultant.signature
}

const USER_UPDATED_ERROR = (state, errors) => {
  if (errors.phoneNumberError !== undefined) {
    state.phoneNumberError = errors.phoneNumberError
  }

  if (errors.firstNameError !== undefined) {
    state.firstNameError = errors.firstNameError
  }
  if (errors.lastNameError !== undefined) {
    state.lastNameError = errors.lastNameError
  }

  if (errors.emailError !== undefined) {
    state.emailError = errors.emailError
  }

  if (errors.systemError !== undefined) {
    state.systemError = errors.systemError
  }
}

const PAYMENT_METHOD_UPDATED_ERROR = (state, errors) => {
  if (errors.phoneNumberError !== undefined) {
    state.phoneNumberError = errors.phoneNumberError
  }

  if (errors.firstNameError !== undefined) {
    state.firstNameError = errors.firstNameError
  }
  if (errors.lastNameError !== undefined) {
    state.lastNameError = errors.lastNameError
  }
}

const PAYMENT_METHOD_ADDED_ERROR = (state, errors) => {
  if (errors.phoneNumberError !== undefined) {
    state.phoneNumberError = errors.phoneNumberError
  }

  if (errors.firstNameError !== undefined) {
    state.firstNameError = errors.firstNameError
  }
  if (errors.lastNameError !== undefined) {
    state.lastNameError = errors.lastNameError
  }
}

export default {
  LOCATION_UPDATED,
  LOCATION_LOADING,
  LOCATION_ERROR,

  CITIES_UPDATED,
  CITIES_LOADING,
  CITIES_ERROR,

  BANKS_UPDATED,
  BANKS_LOADING,
  BANKS_ERROR,

  RECRUITMENT_CHANNELS_UPDATED,
  RECRUITMENT_CHANNELS_LOADING,
  RECRUITMENT_CHANNELS_ERROR,

  NETWORKS_UPDATED,
  NETWORKS_LOADING,
  NETWORKS_ERROR,

  JFORCETYPES_UPDATED,
  JFORCETYPES_LOADING,
  JFORCETYPES_ERROR,

  TIMESLOTS_UPDATED,
  TIMESLOTS_LOADING,
  TIMESLOTS_ERROR,

  LANGUAGES_UPDATED,
  LANGUAGES_LOADING,
  LANGUAGES_ERROR,

  PAYMENT_METHOD_ADDED,
  PAYMENT_METHOD_UPDATED,
  PAYMENT_METHOD_UPDATED_ERROR,
  PAYMENT_METHOD_ADDED_ERROR,
  PAYMENT_METHOD_LOADING,
  PAYMENT_METHOD_ERROR,

  AVAILABLE_PAYMENT_METHODS_UPDATED,
  AVAILABLE_PAYMENT_METHODS_LOADING,
  AVAILABLE_PAYMENT_METHODS_ERROR,

  PAYMENT_METHODS_UPDATED,
  PAYMENT_METHODS_LOADING,
  PAYMENT_METHODS_ERROR,

  USER_UPDATED,
  KYC_FIELDS,
  USER_UPDATED_ERROR,

  TERMS_AND_CONDITIONS_ACCEPTED,
  USER_TYPES_TOGGLE,
  IS_IMPERSONATE
}
